import { stripEmailFromAddressBar } from "utils/urlEmail";

const REGEX_GET_EMAIL = /(?:&|\?)email=([^&]+)/;

const readEmailFromUrl = (): string => {
  const match = window.location.href.match(REGEX_GET_EMAIL);
  return match ? match[1].replace(/%40/g, "@") : "";
};

// Evaluated on import: keep the email in memory and take it out of the address bar.
let landingEmail = readEmailFromUrl();
stripEmailFromAddressBar();

// Used once: opening signup again in the same tab (from Login, or after logout)
// must show an empty form instead of submitting the landing email again.
export const takeLandingEmail = (): string => {
  const email = landingEmail;
  landingEmail = "";
  return email;
};
